export function PuzzleImagePicker({ images, onSelect }) {
  return (
    <div className="puzzle-image-grid">
      {images.map((image) => (
        <button
          className="puzzle-image-option"
          key={image.id}
          onClick={() => onSelect(image)}
          title={image.nome}
          type="button"
        >
          <span>
            <img src={image.url} alt="" loading="lazy" />
          </span>
          <strong>{image.nome}</strong>
        </button>
      ))}
    </div>
  );
}
